<script setup lang="ts">
import { Activity, Clock3, Cpu, ListOrdered } from 'lucide-vue-next'
import { storeToRefs } from 'pinia'
import { computed } from 'vue'
import { useExecutionStore } from '@/stores/domain'

const store = useExecutionStore()
const { slots, queue, leases, executions } = storeToRefs(store)
const activeLeases = computed(() => leases.value.filter((lease) => lease.status === 'active'))
const queued = computed(() => queue.value.filter((entry) => entry.status === 'queued'))
</script>

<template>
  <div class="section-page">
    <header class="section-page__header">
      <div><span class="eyebrow">Execution scheduler</span><h1>Executions</h1><p>Queue priority, active slot leases, and recent Manager runs.</p></div>
    </header>
    <div class="metric-strip">
      <div><span>Active slots</span><strong>{{ slots.active }} <small>of {{ slots.entitled }}</small></strong></div>
      <div><span>Queued</span><strong>{{ queued.length }}</strong></div>
      <div><span>Active leases</span><strong>{{ activeLeases.length }}</strong></div>
      <div><span>Recent runs</span><strong>{{ executions.length }}</strong></div>
    </div>
    <div class="detail-grid">
      <section class="detail-card detail-card--wide">
        <div class="detail-card__head"><div><span class="eyebrow">Queue</span><h2>Waiting work</h2></div><ListOrdered :size="18" /></div>
        <div v-if="queue.length" class="team-list">
          <div v-for="entry in queue" :key="entry.id"><i class="specialist-avatar specialist-avatar--purple"><Clock3 :size="14" /></i><span><strong>{{ entry.kind.replace('_', ' ') }}</strong><small>{{ entry.status }} · priority {{ entry.effectivePriority }}</small></span></div>
        </div><p v-else>The queue is empty.</p>
      </section>
      <section class="detail-card">
        <div class="detail-card__head"><div><span class="eyebrow">Leases</span><h2>Slot ownership</h2></div><Cpu :size="18" /></div>
        <div v-if="activeLeases.length" class="team-list"><div v-for="lease in activeLeases" :key="lease.id"><i class="specialist-avatar specialist-avatar--lime"><Activity :size="14" /></i><span><strong>Slot {{ lease.slotNumber }}</strong><small>Fence {{ lease.fencingToken }} · {{ lease.logicalAgentId }}</small></span></div></div><p v-else>No slots are active.</p>
      </section>
    </div>
  </div>
</template>
